export default __webpack_public_path__ + "9464e1ad30c62b74a308e7ea7d4558e8.png";